module.exports = __webpack_public_path__ + "static/media/quote-wenzel-fearfailure.0eb3993a.png";